export default __webpack_public_path__ + "static/media/uk.59ea7b04.svg";